import { render, staticRenderFns } from "./softwareDevelopment.vue?vue&type=template&id=5de0fa06&lang=html&"
import script from "./softwareDevelopment.vue?vue&type=script&lang=js&"
export * from "./softwareDevelopment.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/service.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "softwareDevelopment.vue"
export default component.exports